var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myrow",staticStyle:{"transition":"1s","opacity":"1","position":"relative"},attrs:{"id":"wizcon"}},[_c('div',{staticStyle:{"transition":"1s"},style:({ width: _vm.widthtc + 'px' })},[_c('v-stage',{attrs:{"config":{ width: _vm.widthtc, height: 2080 * 0.25, draggable: false, zoombool: true }}},[_c('drzwi')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }